import { FC } from 'react';
import { useIntl } from 'react-intl';
import { times } from 'lodash';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { sharedMessages } from '@app/translations';

import './FacetContentSpinner.scss';

interface FacetContentSpinnerProps {
  onFocusChange: (isFocused: boolean) => void;
}

const cnBem = createBemBlockBuilder(['facetContentSpinner']);

export const FacetContentSpinner: FC<FacetContentSpinnerProps> = ({
  onFocusChange,
}) => {
  const { $t } = useIntl();
  const rowsCount = 6;

  return (
    <div
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      aria-label={$t(sharedMessages.loadingMessage)}
      data-auto="facet-content-spinner"
      onFocus={() => onFocusChange(true)}
      onBlur={() => onFocusChange(false)}
    >
      {times(rowsCount, index => (
        <div key={index} className={cnBem('__row')} />
      ))}
    </div>
  );
};
